import * as React from "react";
const SvgFiRrEnvelopeBulk = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-envelope-bulk_svg__a)">
      <path
        fill="#062147"
        d="M20 6h-1V4c0-2.206-1.794-4-4-4H7C4.794 0 3 1.794 3 4v5c0 .739.201 1.431.552 2.025A4.005 4.005 0 0 0 0 15v5c0 2.206 1.794 4 4 4h8c2.206 0 4-1.794 4-4v-1h4c2.206 0 4-1.794 4-4v-5c0-2.206-1.794-4-4-4M5 4c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2h-5c-2.206 0-4 1.794-4 4v1H7c-1.103 0-2-.897-2-2zm7 9q.27.001.518.068L8.995 16.59c-.527.527-1.446.527-1.975 0l-3.526-3.526q.243-.064.505-.065zm2 7c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2v-5q0-.276.072-.53l3.535 3.535A3.37 3.37 0 0 0 8.009 19c.907 0 1.761-.354 2.402-.995l3.522-3.522q.067.248.068.517zm8-5c0 1.103-.897 2-2 2h-4v-2c0-2.206-1.794-4-4-4h-2v-1c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2zm-2-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-envelope-bulk_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEnvelopeBulk;
